module.exports = __webpack_public_path__ + "static/duke_zalto-e55c50fe6caa16a25a58ea58c59d67e7.jpg";